import { graphql } from '@/gql/codegen/gql';
import { useSuspenseQuery } from '@apollo/client';
import { createFileRoute } from '@tanstack/react-router';

import { HeadData } from '@/components/HeadData';
import { CourseLessonsContainer } from './-container';

export const GET_USER_ATTENDANCE = graphql(/* GraphQL */ `
  query EmbaUserAttendanceForLearnerPage(
    $embaUserAttendanceSlug: String!
    $embaCourseLessonSlug: String
  ) {
    embaUserAttendance(
      embaUserAttendanceSlug: $embaUserAttendanceSlug
      embaCourseLessonSlug: $embaCourseLessonSlug
    ) {
      ...EmbaUserAttendanceForLearnerPage
      embaCourse {
        name
      }
    }
  }
`);

export const Route = createFileRoute(
  '/_embaUserLayout/_learnerLayout/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/',
)({
  component: component,
});

function component() {
  const { attendanceSlug } = Route.useParams();

  const { error, data } = useSuspenseQuery(GET_USER_ATTENDANCE, {
    variables: {
      embaUserAttendanceSlug: attendanceSlug,
    },
  });

  if (error) {
    throw error;
  }

  return (
    <>
      <HeadData title={data.embaUserAttendance.embaCourse.name} />
      <CourseLessonsContainer embaUserAttendance={data.embaUserAttendance} />
    </>
  );
}
